module.exports = __webpack_public_path__ + "static/media/speakersprofile_stand.2aa4b4df.png";